export const getCountryIdFromName = (countries, countryName) =>
  countries?.find(country => country?.country_name === countryName)?.id || '';
